module.exports = __webpack_public_path__ + "img/close.a8f7ac35.svg";